<div class="auth-form-wrapper">
  <div class="auth-logo">
    <img src="logo-white.svg" alt="logo" />
    <p class="mt-2">Urban Infrastructure Management System</p>
  </div>

  <div class="auth-form">
    <h1 class="text-3xl mb-7 text-center">Авторизация</h1>
    <ui-form
      [form]="form"
      (linkClicked)="onLinked($event)"
      [config]="formConfig"
      (enterPressed)="onSubmit()"
    >
    </ui-form>

    <ui-button
      type="primary"
      [block]="true"
      (click)="onSubmit()"
      [disabled]="isFormInvalid"
      [loading]="isFormSubmitting"
      >Войти
    </ui-button>
  </div>
</div>

<img class="auth-bg" src="assets/images/bg.webp" alt="uims-bg" />
